import { Routes } from '@angular/router';

export const loginRoutes: Routes = [
    {
        path: '',
        loadComponent: () => import('./login.component').then(m => m.LoginComponent)
    },
    {
      path: 'login',
      loadComponent: () => import('./login.component').then(m => m.LoginComponent)
    },
    {
      path: 'autologin/:string',
      loadComponent: () => import('../autologin/autologin.component').then(m => m.AutologinComponent)
    }
];
